export enum DocuResponsiblesTableMode {
  DEFAULT = 'default',
  NEW_PROJECT = 'newProject',
}
